import axios from 'axios'

import { getProfile } from './profile'
import { getRegions } from './regions'

export const getProfileAndRegions = async () => {
  const response = await axios
    .all([getProfile(), getRegions()])
    .then(
      axios.spread((profile, regions) => ({ profile: profile.data, regions }))
    )
    .catch(err => {
      throw err.response
    })

  return response
}
